import React from "react";
import Icon, { type IconComponent } from "@/icons/base";

const CheckIcon: IconComponent = ({ ...props }) => (
  <Icon {...props}>
    <path
      d="m13.6330585 2.3240841c.2354958-.34119661.7026401-.42663719 1.0433961-.19083687.3407559.23580031.4260862.70354874.1905904 1.04474536l-6.64940802 9.63395411c-1.07619735 1.5591793-3.36718666 1.5889313-4.48336622.0582163l-2.58995-3.55188737c-.24425098-.33496862-.17106051-.80477494.16347549-1.04934178.33453599-.24456685.80373555-.17128173 1.04798653.16368689l2.58994635 3.55188236c.5073514.6957755 1.54874183.6822515 2.03792942-.0264765z"
      fill="currentColor"
    />
  </Icon>
);

export default CheckIcon;
